import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Detailed Top Up Report"
  reportDownloadName = "detailedTopupReport"
  apiReportName = "detailedTopupReport"
  downloadOnly = {true}
/>
